import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
var moment = require('moment');
class CompletedActivity extends React.Component {
    completedClick = async () => {
        this.props.completedClick(false);
        this.props.selectedActivityData.oldRunStatus = this.props.selectedActivityData.runStatus;
        this.props.selectedActivityData.runStatus = 2
        this.props.selectedActivityData.onHoldFlag = false;
        this.props.selectedActivityData.issueFlag = false;
        this.props.selectedActivityData.progress = 100;
        this.props.selectedActivityData.completeActivitystring = "MarkAsComplete";
        this.props.selectedActivityData.string = "";
        this.props.selectedActivityData.actualEndDate = moment();
        if (this.props.activeTab === "myactivities") {
           await dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
        }
        else {
            await dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData);
            // :Fetching the initiatives count 
            let payload = {
                organizationId: this.props.selectedOrganisation.id
            }
            await dispatch.initiatives.getinitiativesCount(payload);
        }
    }
    close = () => {
        if (this.props.selectedActivityData.progress === 100) {
            this.props.selectedActivityData.progress = 99;
        }
        if (this.props.from === "activityCard") {
            this.props.selectedActivityData.completeActivitystring = "";
            this.props.selectedActivityData.string = "";
            this.props.selectedActivityData.progress = this.props.existingProgress;
            if (this.props.activeTab === "myactivities") {
                dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            }
            else {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
        }
        this.props.completedClick(false);
    }
    render() {
        return (
            <Modal
                className="EditModalCard basicModal"
                open={this.props.open}
                size='mini'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {!this.props.selectedActivityData.issueFlag ?
                        "Activity Completed" : this.props.selectedActivityData.name
                    }
                </Modal.Header>
                <Modal.Content>
                    {/* <strong >
                        {this.props.selectedActivityData ?
                            this.props.selectedActivityData.name : ''}
                    </strong> */}
                    {!this.props.selectedActivityData.issueFlag ?
                        <span >Are you sure you want to mark this activity as completed?</span>
                        :
                        <span >This activity has an issue. Please resolve it before marking the activity as complete.</span>
                    }
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={!this.props.selectedActivityData.issueFlag ? "Cancel" : "Ok"}
                        className={!this.props.selectedActivityData.issueFlag ? "button-cancel" : "button-submit"}
                        onClick={this.close} />
                    {!this.props.selectedActivityData.issueFlag && <Button content='Mark as Complete' className="button-submit" onClick={this.completedClick} />}

                </Modal.Actions>
            </Modal>
        )
    }
}
export default CompletedActivity;